module.exports = __webpack_public_path__ + "img/fbcloud.png.0f920d90.webp";